const lang = {
  modal_delete_content: '<b>{num}件の項目が削除されます。</b><br>削除した案件情報は、復元できません。本当に削除してよろしいでしょうか？',
  modal_delete_title: '削除確認',
  modal_edit_name_title: '項目名変更',
  title: '項目名',
  input_name: '項目名を入力',
  construction_info: '案件情報編集',
  btn_select: '選択',
  btn_cancel: 'キャンセル',
  input_content: '項目内容を入力',
  add_info: '+項目追加'
}

export default lang



// WEBPACK FOOTER //
// ./src/lang/ja/pages/project/updateInfo.js